export default function ({ redirect, route, $auth }) {
  if ($auth.loggedIn && $auth.user && !$auth.user.userType) {
    const whiteListRouteName = ['signup-username', 'signup-role', 'login']
    if (!whiteListRouteName.includes(route.name)) {
      redirect('/signup/role')
    }
  }
}
